import {useEffect, useState} from "react";
import {createCheckoutSession, getOrders} from "../../../api/ApiSubscription";
import useProject from "../../../util/useProject";
import {useTranslation} from "react-i18next";
import {useSearchParams} from "react-router";
import useNetwork from "../../../util/useNetwork";

const useSettingsSubscription = () => {
  const {expirationDate} = useProject();
  const {handleNetworkError} = useNetwork();

  const [queryParams] = useSearchParams();
  const {t} = useTranslation("settings_subscription");
  const {t: tApp} = useTranslation("app");

  const [renewing, setRenewing] = useState(false);
  const [orders, setOrders] = useState();

  const renew = () => {
    setRenewing(true);

    createCheckoutSession()
      .then(url => window.location.href = url)
      .catch(handleNetworkError);
  }

  useEffect(() => {
    getOrders().then(setOrders).catch(handleNetworkError);
  }, [expirationDate, handleNetworkError]);

  return {
    t,
    tApp,
    expirationDate,
    orders,
    renew,
    renewing,
    orderSuccess: queryParams.has("success") && queryParams.get("success") === "true"
  };
};

export default useSettingsSubscription;
